import React, { useState, useEffect, lazy, Suspense } from 'react';
import styled from 'styled-components';
import Banner from './components/Banner';
import { ReactComponent as FellowFlorist } from './assets/Images/fellowFlorist.svg';
import { Container, Row, Col } from 'react-bootstrap';
import { ReactComponent as InfoCircle } from '../forum/assets/images/info-circle.svg';

import {
  useGetFloristDropDownPublicQuery,
  useGetAllFloristByRadiusPublicQuery,
} from './vendorsApiSlice';
import SeoHead from '../../app/components/SeoHead';
import StyledLoading from '../../app/components/loading/StyledLoading';

const Vendors = lazy(() => import('./Vendors'));

const seoData = {
  title: 'Florists',
  description:
    'Building and Hosting your e-commerce Floral Website has never been easier or quicker.  The BoostFloral platform addresses the specific needs of Florists.',
  keywords:
    'Flower Shop Websites, Floral Web Design Software, Floral CMS, Building a Floral Website',
  ogTitle: 'Florists',
  ogDescription:
    'Building and Hosting your e-commerce Floral Website has never been easier or quicker with the Number 1 Floral Web Design Software.  The BoostFloral software addresses the specific needs of Florists.',
  ogType: 'company',
  ogSiteName: 'BoostFloral',
};

const VendorsInfo = () => {
  var options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0,
  };

  const [coordinates, setCoordinates] = useState(undefined);
  const [radius, setRadius] = useState(200);
  const [search, setSearch] = useState('');
  const [mapCenterPoint, setMapCenterPoint] = useState({
    lat: undefined,
    lng: undefined,
  });
  const [services, setServices] = useState([]);
  const [saved, setSaved] = useState(false);

  const { data: vendorsWithLatLng } = useGetAllFloristByRadiusPublicQuery(
    {
      filter: JSON.stringify({
        search,
        radius,
        lat: mapCenterPoint.lat,
        long: mapCenterPoint.lng,
        unit: 'N',
        services,
        saved,
      }),
    },
    {
      refetchOnMountOrArgChange: true,
    },
  );

  const { data: floristDropDown } = useGetFloristDropDownPublicQuery();

  const success = (pos) => {
    setCoordinates(pos.coords);
  };

  const errors = () => {};

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.permissions
        .query({ name: 'geolocation' })
        .then(function (result) {
          if (result.state === 'granted') {
            //If granted then you can directly call your function here
            navigator.geolocation.getCurrentPosition(success, errors, options);
          } else if (result.state === 'prompt') {
            navigator.geolocation.getCurrentPosition(success, errors, options);
          } else if (result.state === 'denied') {
            //If denied then you have to show instructions to enable location
            alert('Please enable your browser location');
          }
          result.onchange = function () {};
        });
    } else {
      alert('Sorry Not available!');
    }
  }, []);

  return (
    <RootContainer>
      <SeoHead data={seoData} />
      <Banner />
      <FellowFloristContainer>
        <div className="text-center">
          <h1>Fellow Florists </h1>
          <FellowFlorist />
        </div>
        <Container>
          <RowStyle>
            <Col md="12" className="mt-5">
              {coordinates && (
                <Suspense fallback={<StyledLoading />}>
                  <Vendors
                    isComeWithLogin={false}
                    floristDetails={{
                      objectData: {
                        latitude: coordinates.latitude,
                        longitude: coordinates.longitude,
                      },
                    }}
                    vendorsWithLatLng={vendorsWithLatLng}
                    favoriteFloristList={[]}
                    floristDropDown={floristDropDown}
                    radius={radius}
                    search={search}
                    mapCenterPoint={mapCenterPoint}
                    setSearchField={setSearch}
                    setRadius={setRadius}
                    setMapCenterPoint={setMapCenterPoint}
                    setServices={setServices}
                    setSaved={setSaved}
                  />
                </Suspense>
              )}
            </Col>
            <Col md="12">
              <SignInBox>
                <InfoCircle />
                Find a Florist to fill your Floral or Gift Deliveries in Seconds
              </SignInBox>
            </Col>
          </RowStyle>
        </Container>
      </FellowFloristContainer>
    </RootContainer>
  );
};

const RootContainer = styled.div``;
const FellowFloristContainer = styled.div`
  padding: 100px 0px;
  background: white;
  h1 {
    line-height: 1.36;
    font-size: 38px;
    font-weight: 400;
    font-family: 'Source Serif 4', serif;
    color: ${({ theme }) => theme.secondaryLight};
    position: relative;
    margin-bottom: 0;
  }
`;
const SignInBox = styled.p`
  border-radius: 7px;
  font-size: 14px;
  font-weight: 500;
  line-height: 19px;
  padding: 12px;
  margin: 32px 10px 0px;

  border: 1.25px solid ${({ theme }) => theme.lightGray1};
  z-index: 999;
  svg {
    margin-right: 10px;
  }
  &.selling-alert {
    color: ${({ theme }) => theme.primaryDark};
  }
`;

const RowStyle = styled(Row)`
  position: relative;
  z-index: 2;
`;

export default VendorsInfo;
